import { j as s } from "../../jsx-runtime-82a9ddf6.js";
import { Q as e } from "../../react-toastify.esm-a636d9b1.js";
import { CustomToast as m } from "./components.js";
const f = (r, o, t) => {
  o || (o = r === "error" ? "Unexpected Error" : "Your request has been processed."), e(/* @__PURE__ */ s.jsx(m, { message: o, type: r, small: t }), { type: r });
};
export {
  f as toastAlert
};
